import React, { useEffect, useRef } from "react";

import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

type InfiniteScrollProps = {
  onScrollEnd: () => unknown;
  hasMore?: boolean;
  children: React.ReactNode;
  loading?: boolean;
};

const InfiniteScroll = ({ children, onScrollEnd, hasMore, loading }: InfiniteScrollProps) => {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;

    if (!sentinel || !hasMore) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onScrollEnd();
        }
      },
      {
        rootMargin: "100px",
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [hasMore, onScrollEnd]);

  return (
    <>
      {children}
      {hasMore && (
        <Box ref={sentinelRef} padding="x-large" align="center">
          {loading && (
            <Typography tag="span" variant="p-body2" color="secondary">
              Loading more...
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};

export default InfiniteScroll;
